// extracted by mini-css-extract-plugin
export var container = "section-benefit-module--container--vu3EH";
export var contents = "section-benefit-module--contents--u5tZR";
export var list = "section-benefit-module--list--xeBMy";
export var item = "section-benefit-module--item--JKiYO";
export var item_number = "section-benefit-module--item_number--kyg0i";
export var item_title = "section-benefit-module--item_title--AjLlr";
export var item_content = "section-benefit-module--item_content--8z2PA";
export var item_img = "section-benefit-module--item_img--dED59";
export var item_desc = "section-benefit-module--item_desc--i36OJ";